import { addMonths, isBefore } from "date-fns"
import { useEditMode } from "@/modules/patients/detail/hooks/useEditMode"
import { usePatientEpisodesOfCareData } from "@/modules/patients/hooks/usePatientEpisodesOfCareData"
import { useProgressNoteData } from "@/modules/patients/hooks/useProgressNoteData"

const NUMBER_OF_DISPLAYED_PROGRESS_NOTE = 10

const useFollowUpProgressNotes = (followUpProgressNoteId?: string) => {
  const patientEpisodesOfCareData = usePatientEpisodesOfCareData()
  const isEditMode = useEditMode()
  const progressNoteData = useProgressNoteData(patientEpisodesOfCareData, isEditMode)

  return progressNoteData.progressNoteAndParentData
    .filter(
      (e) =>
        (e.episodeOfCareProgressNoteData.appointment.status !== "CANCELLED" &&
          isBefore(new Date(), addMonths(e.episodeOfCareProgressNoteData.updatedAt, 3)) &&
          (!e.episodeOfCareProgressNoteData.followUpAppointment ||
            e.episodeOfCareProgressNoteData.followUpAppointment.status === "CANCELLED") &&
          e.episodeOfCareProgressNoteData.kind === "MEDICAL") ||
        e.episodeOfCareProgressNoteData.id === followUpProgressNoteId,
    )
    .slice(0, NUMBER_OF_DISPLAYED_PROGRESS_NOTE)
}

export { useFollowUpProgressNotes }
